/**
 * Labstep
 *
 * @module components/ProtocolCollection/SearchSelect
 * @desc Protocol Search Select
 */

import { SearchSelectContainer as SearchSelect } from 'labstep-web/core/Select/Search';
import type { Protocol } from 'labstep-web/models/protocol.model';
import type { ProtocolCollection } from 'labstep-web/models/protocol-collection.model';
import type React from 'react';
import type { IProtocolCollectionSearchSelectProps } from './types';

export const ProtocolCollectionSearchSelect: React.FC<
  IProtocolCollectionSearchSelectProps
> = ({ params, returnProtocolCollection, ...rest }) => (
  <SearchSelect
    labelKey="label"
    isClearable={false}
    setOptions={(protocolCollections: ProtocolCollection[]) =>
      protocolCollections
        .filter(
          (protocolCollection: ProtocolCollection) =>
            protocolCollection.last_version,
        )
        .map((protocolCollection: ProtocolCollection) => {
          if (returnProtocolCollection) {
            return {
              guid: protocolCollection.guid,
              label: protocolCollection.displayName,
            };
          }
          const lastVersion =
            protocolCollection.last_version as Protocol;
          const { displayName: label } = protocolCollection;
          return { id: lastVersion.id, label };
        })
    }
    entityName="protocol_collection"
    params={{ has_last_version: true, ...params }}
    {...rest}
  />
);
